// extracted by mini-css-extract-plugin
export default {"pdfReportViewerContainer":"PdfReportViewer_pdfReportViewerContainer__9tH-0"};